import type { Prototype } from "../prototype-types";

export const michalJezPrototypes: Prototype[] = [
  {
    id: "playground-v2",
    name: "Playground V2",
    path: "/mj/playground-v2",
    description: "Playground V2",
    owner: "Michal Jez",
    createdAt: "2026-04-10",
    lastUpdated: "2026-04-10",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9b49a18c6a919dc000702271ce2852ba7bf2c3cd72e0101ff16f2e4186ee4588.png",
  },
];
